import axios from '@/utils/request'

// 学员讨论区管理列表
export function getList(params) {
  return axios.get('/admin_api/v1/comment/products/', {
    params
  })
}

// 【讨论区】当前大纲下拉列表
export function getCommentProductInfo(product_uuid, params) {
  return axios.get(`/admin_api/v1/comment/${product_uuid}/product_info/`, {
    params,
  })
}

//【讨论区】学员讨论详情列表页
export function getDetailList(product_id, subject_id, params) {
  return axios.get(`/admin_api/v1/comment/${product_id}/${subject_id}/`, {
    params,
  })
}

// 【讨论区】获取章节课节下啦列表
export function getChapterList(product_uuid, subject_uuid, params) {
  return axios.get(`/admin_api/v1/comment/${product_uuid}/${subject_uuid}/chapter`, {
    params,
  })
}

// 讨论/评论详情
export function getComment(comment_id) {
  return axios.get(`/admin_api/v1/comment/${comment_id}/`)
}

// 教师回复
export function postCommentAdd(data) {
  return axios.post('/admin_api/v1/comment/add/', data)
}

// 审核(包括批量)
export function putCommentAudit(data) {
  return axios.put(`/admin_api/v1/comment/audit/`, data)
}

// 展示(包含批量)
export function putCommentShow(data) {
  return axios.put(`/admin_api/v1/comment/show/`, data)
}

// 置顶(包含批量)
export function putCommentTop(data) {
  return axios.put(`/admin_api/v1/comment/top/`, data)
}

// 审核不通过评论恢复
export function putCommentReAudit(comment_id) {
  return axios.put(`/admin_api/v1/comment/${comment_id}/reaudit/`)
}

// 【讨论区】回复教师列表
export function getProductTeachers(product_uuid) {
  return axios.get(`/admin_api/v1/comment/${product_uuid}/teachers/`)
}

// 【讨论区】删除用户评论
export function deleteComment(comment_id) {
  return axios.delete(`/admin_api/v1/comment/${comment_id}/`)
}

// 【讨论区】教师评论修改
export function putCommentModify(comment_id, data) {
  return axios.put(`/admin_api/v1/comment/${comment_id}/`, data)
}

